<template>
  <div ref="sectionRef" class="technology-section">
    <!-- 标题区域 -->
    <div class="technology-header">
      <div class="technology-header-content">
        <div>
          <TextCom contentId="technology-title-en" />
        </div>
        <TextCom contentId="technology-title" />
      </div>
      <div ref="headerLineRef" class="technology-header-line">Technology</div>
    </div>
    <!-- 技术特性卡片区域 -->
    <div class="technology-features">
      <div class="features-container">
        <!-- 特性卡片1 -->
        <div class="feature-card">
          <div class="feature-content">
            <div>
              <TextCom contentId="technology-feature-1-title" />
            </div>
            <TextCom contentId="technology-feature-1-desc" />
          </div>
          <div class="feature-image-container">
            <ContainerCom :showLoadingOverlay="false" contentId="p-1" />
          </div>
        </div>

        <!-- 特性卡片2 -->
        <div class="feature-card">
          <div class="feature-content">
            <div>
              <TextCom contentId="technology-feature-2-title" />
            </div>
            <TextCom contentId="technology-feature-2-desc" />
          </div>
          <div class="feature-image-container">
            <ContainerCom :showLoadingOverlay="false" contentId="p-2" />
          </div>
        </div>

        <!-- 特性卡片3 -->
        <div class="feature-card">
          <div class="feature-content">
            <div>
              <TextCom contentId="technology-feature-3-title" />
            </div>
            <TextCom contentId="technology-feature-3-desc" />
          </div>
          <div class="feature-image-container">
            <ContainerCom :showLoadingOverlay="false" contentId="p-3" />
          </div>
        </div>

        <!-- 特性卡片4 -->
        <div class="feature-card">
          <div class="feature-content">
            <div>
              <TextCom contentId="technology-feature-4-title" />
            </div>
            <TextCom contentId="technology-feature-4-desc" />
          </div>
          <div class="feature-image-container">
            <ContainerCom :showLoadingOverlay="false" contentId="p-4" />
          </div>
        </div>
      </div>
    </div>
    <div class="illustration-container">
      <!-- 技术插图区域 -->
      <!-- <ContainerCom contentId="technology-illustration"> </ContainerCom> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";

// 引用目标元素
const headerLineRef = ref(null);
const sectionRef = ref(null);
// 记录上一次滚动位置
let lastScrollTop = 0;
// 记录元素初始位置
let initialLeft = 0;
// 滚动速度系数，控制移动速度
const scrollSpeed = 0.5;
// 记录section元素的初始位置
let sectionOffsetTop = 0;
// 记录section元素的高度
let sectionHeight = 0;

// 处理滚动事件
const handleScroll = () => {
  if (!headerLineRef.value || !sectionRef.value) return;

  // 获取当前滚动位置
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // 计算section元素相对于视口的位置
  const sectionTop = sectionOffsetTop - scrollTop;

  // 当section元素进入视口时（顶部进入视口）
  if (sectionTop < window.innerHeight && sectionTop + sectionHeight > 0) {
    // 计算section元素顶部与视口顶部的距离
    const distanceFromTop = Math.max(0, window.innerHeight - sectionTop);

    // 计算滚动距离和方向
    const scrollDistance = scrollTop - lastScrollTop;
    const scrollDirection = scrollDistance > 0 ? "down" : "up";

    // 获取元素当前位置
    const currentTransform = window.getComputedStyle(
      headerLineRef.value
    ).transform;
    const matrix = new DOMMatrix(currentTransform);
    let translateX = matrix.m41;

    // 根据滚动方向调整元素位置
    if (scrollDirection === "down") {
      // 向下滚动，向右移动
      translateX += Math.abs(scrollDistance) * scrollSpeed;
      // 限制向右移动最多300px
      translateX = Math.min(translateX, 200);
    } else {
      // 向上滚动，向左移动
      translateX -= Math.abs(scrollDistance) * scrollSpeed;
      // 限制向左移动不超过初始位置
      translateX = Math.max(translateX, 0);
    }

    // 应用新位置
    headerLineRef.value.style.transform = `translateX(${translateX}px)`;
  } else if (sectionTop >= window.innerHeight) {
    // 当section元素完全在视口下方时，重置位置
    headerLineRef.value.style.transform = "translateX(0px)";
  }

  // 更新上一次滚动位置
  lastScrollTop = scrollTop;
};

// 组件挂载时添加滚动事件监听
onMounted(() => {
  if (headerLineRef.value && sectionRef.value) {
    // 记录初始位置
    initialLeft = headerLineRef.value.offsetLeft;
    // 获取section元素的位置和高度
    const rect = sectionRef.value.getBoundingClientRect();
    sectionOffsetTop = rect.top + window.pageYOffset;
    sectionHeight = rect.height;
  }
  window.addEventListener("scroll", handleScroll);
});

// 组件卸载时移除滚动事件监听
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.technology-header-line {
  font-size: 8rem;
  font-weight: bold;
  color: #dde3e8;
  cursor: default;
}
.technology-header-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.feature-image-container {
  height: 350px;
}
.technology-section {
  width: 100%;
  background-color: #f1f6fa;
}

/* 标题区域样式 */
.technology-header {
  display: flex;
  justify-content: space-between;
  padding: 6vh 0 40px 8vw;
}

/* .technology-header::after {
  content: "Technology";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 120px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.05);
  z-index: 0;
  white-space: nowrap;
} */

/* 技术特性卡片区域样式 */
.technology-features {
  padding: 6vh 8vw 50px;
  /* background-color: #ffffff; */
}

.features-container {
  /* max-width: 1200px; */
  /* margin: 0 auto; */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* grid-auto-flow: column; */
  gap: 40px;
  position: relative;
  z-index: 1;
  pointer-events: auto;
  /* overflow-x: auto;
  padding-bottom: 20px;
  scrollbar-width: thin; */
}

.feature-card {
  display: flex;
  flex-direction: column;
}
.feature-content {
  padding-bottom: 60px;
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 120px;
}

/* .feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
} */

/* 技术插图区域样式 */
.illustration-container {
  position: absolute;
  /* top: 50%; */
  /* left: 50%; */
  /* transform: translate(-50%, -50%); */
  transform: translateY(-450px);
  height: 450px;
  width: 100%;
  background-color: #dde3e8
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feature-image-container{
    padding: 12px;
    background: #3f98d6;
    border-radius: 12px;
  }
  .illustration-container {
    display: none;
  }
  .technology-header {
    padding: 40px 20px;
    flex-direction: column;
    text-align: center;
  }
  .feature-image-container {
    /* height: 650px; */
  }

  .technology-header::after {
    font-size: 60px;
  }

  .features-container {
    /* grid-template-columns: 1fr; */
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  .feature-card {
    padding: 20px;
    display: flex;
    flex-direction: column-reverse;
    
  }
  .feature-content{
    padding-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 60px;
  margin-bottom: 0;
  }

  .illustration-container {
    height: 300px;
  }
}
/* 小屏幕 */
@media (max-width: 480px) {
  .feature-image-container {
    /* width: 300px;
    height: 450px; */
  }
}
</style>
